export interface DrivingExemptionQuestion {
    key: string,
    value: string,
    altValue?: string,
    tooltip?: string
}

const DrivingExemptionQuestions = {
    positionLevel: {
        key: 'positionLevel',
        value: 'Position ID.'
    },
    reportToEmail: {
        key: 'reportToEmail',
        value: 'Your 1-Up Leader.'
    },
    deptManagerId: {
        key: 'deptManagerId',
        value: 'Please select your Department Manager from the below list.'
    },
    dssInstalled: {
        key: 'dssInstalled',
        value: 'Does the vehicle have Driver Safety System (DSS) installed?'
    },
    bhpOwnedOrHiredLV: {
        key: 'bhpOwnedOrHiredLV',
        value: 'Will you be driving \'BHP- Owned\', \'Hired\' or \'Contract Partner\' light vehicle for your travel?'
    },
    monitoringSystemInstalled: {
        key: 'monitoringSystemInstalled',
        value: 'Does the Hired Light Vehicle have fleet monitoring system installed?'
    },
    hiredLVMonitoringSysInstallationArrangements: {
        key: 'hiredLVMonitoringSysInstallationArrangements',
        value: 'Please provide details of what arrangements have been made to procure and install the fleet monitoring system for your light vehicle.'
    },
    lvAssetName: {
        key: 'lvAssetName',
        value: 'Please provide the asset name of the Light Vehicle (Decal on side door panels e.g. B1234, R123 etc)'
    },
    lvRegistrationNumber: {
        key: 'lvRegistrationNumber',
        value: 'Please provide the asset registration of the Light Vehicle.' // Question for the LV Commute form
    },
    drivingExemptionJustification: {
        key: 'drivingExemptionJustification',
        value: 'Please provide justification for your request for a 12mth exemption.'
    },
    requiredToAttendSiteoutsideOfNormalBusiness: {
        key: 'requiredToAttendSiteoutsideOfNormalBusiness',
        value: 'Are you required to attend site outside of normal business?' // Question for the LV Commute form
    },
    twelveMonthsExemption: {
        key: 'twelveMonthsExemption',
        value: 'Driving exemption request for 12 months.'
    },
    startDate: {
        key: 'startDate',
        value: 'Start date.'
    },
    endDate: {
        key: 'endDate',
        value: 'End date.'
    },
    hoursOfDriving: {
        key: 'hoursOfDriving',
        value: 'Do you require additional approval to drive on the Great Northern Highway at night?'
    },
    gnhTermsAcknowledgement: {
        key: 'gnhTermsAcknowledgement',
        value: `<b>Request For Exemption</b><br/>
        This form is for Rail employees & embedded contractors who are required to travel on the Great Northern Highway(GNH) regularly for their job and requesting exemption for the requirement of GM/ Manager approval each time they drive BHP owned or operated light vehicles on the GNH (distances greater than 10kms).<br/>

        <b>Please Note</b><br/>
        An approved exemption does not supersede the requirement for line leader approval, JMP and additional controls for GNH travel, when driving distances greater than 10km from point of departure to point of arrival.<br/>

        Exemptions remain valid for a period of 12mths from the date of Rail General Manager approval.After the expiry date, a new request for 12mth exemption will be required.<br/>

        This form will workflow to your Departmental Manager for endorsement before seeking approval from the Rail General Manager.`,
    },
    lvCommuteTermsAcknowledgement: {
        key: 'lvCommuteTermsAcknowledgement',
        value: `<b>Request For Exemption</b><br/>
        This form is for Rail employees & embedded contractors seeking approval to utilise a BHP light vehicle for travel between a residential address and/or camp where it is not outlined in an employment contract.<br/>

        The Port & Rail Light Vehicle Policy states that <i>travel to and from camp shall fully utilise arranged bus services as far as practicable</i>. Site vehicles, pool vehicles and benefit vehicles are not to be used for the purpose of commuting between work and home unless approval has been granted from relevant Rail Department Manager and General Manager`,
    },
    onBehalfUser: {
        key: 'user',
        value: 'User',
        tooltip: 'Who are you submitting the on-behalf form for?'
    },
    lVTravelShift: {
        key: 'lVTravelShift',
        value: 'Do you require additional approval for nightshift?'
    }
}

export default DrivingExemptionQuestions;